export default Object.freeze({
  DOWNLOAD_DELIVERY_RETURN_EXCEL: '택배사 반품 양식 다운',
  SET_DELIVERY_RETURN_EXCEL: '양식 설정',

  ALREADY_DELIVERY_COMBINE_WITHDRAWAL: '배송번호 단위로 출고처리가 가능합니다. 해당 클레임은 자동철회되니 배송번호 확인 후 출고 처리해 주세요.',
  ALREADY_DELIVERY_NORMAL_WITHDRAWAL: '묶음배송처리된 주문은 묶음단위로 출고처리가 가능합니다. 해당 클레임은 자동철회되니 배송준비중 리스트에서 출고 처리해 주세요.'
})